const listAttributes = ['groupId', 'name', 'users', 'basePermissions', 'currPermissions'] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = ['name'] as const;

export const PermissionGroupAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
